class PriceRangeSlider {
  constructor(container) {
    this.container = container;
    const numberInputs = container.querySelectorAll('input:not([type="hidden"])');
    if (numberInputs.length < 2) return;

   this.minInput = numberInputs[0];
    this.maxInput = numberInputs[1];
    this.rangeMin = 0;

    // Dawn's price inputs don't carry a real max/min HTML attribute — the true
    // ceiling is only shown as text like "The highest price is $59.00" nearby.
    // Grab that number instead of trusting input attributes.
    const infoEl = (container.closest('.mobile-facets__submenu, .facets__display, .facets__display-vertical') || document)
      .querySelector('.mobile-facets__info, .facets__selected');
    const parsedMax = infoEl ? infoEl.textContent.match(/[\d,]+\.?\d*/) : null;
    this.rangeMax = parsedMax ? parseFloat(parsedMax[0].replace(/,/g, '')) : 1000;

    this.currencySymbol = container.querySelector('.field-currency')?.textContent.trim() || '$';

    this.build();
  }

  build() {
    this.container.setAttribute('data-slider-init', 'true');

    const wrapper = document.createElement('div');
    wrapper.className = 'price-slider';

    const track = document.createElement('div');
    track.className = 'price-slider__track';
    const fill = document.createElement('div');
    fill.className = 'price-slider__range';
    track.appendChild(fill);

    const minRange = document.createElement('input');
    minRange.type = 'range';
    minRange.className = 'price-slider__input';
    minRange.min = this.rangeMin;
    minRange.max = this.rangeMax;
    minRange.value = this.minInput.value || this.rangeMin;

    const maxRange = document.createElement('input');
    maxRange.type = 'range';
    maxRange.className = 'price-slider__input';
    maxRange.min = this.rangeMin;
    maxRange.max = this.rangeMax;
    maxRange.value = this.maxInput.value || this.rangeMax;

    const values = document.createElement('div');
    values.className = 'price-slider__values';
    values.innerHTML = '<span data-min-label></span><span>-</span><span data-max-label></span>';

    wrapper.appendChild(track);
    wrapper.appendChild(minRange);
    wrapper.appendChild(maxRange);
    wrapper.appendChild(values);
    this.container.insertAdjacentElement('afterbegin', wrapper);

    this.minRange = minRange;
    this.maxRange = maxRange;
    this.fill = fill;
    this.minLabel = values.querySelector('[data-min-label]');
    this.maxLabel = values.querySelector('[data-max-label]');

    minRange.addEventListener('input', () => this.onDrag('min'));
    maxRange.addEventListener('input', () => this.onDrag('max'));
    minRange.addEventListener('change', () => this.commit());
    maxRange.addEventListener('change', () => this.commit());

    this.updateUI();
  }

  onDrag(which) {
    if (which === 'min' && Number(this.minRange.value) > Number(this.maxRange.value) - 1) {
      this.minRange.value = Number(this.maxRange.value) - 1;
    }
    if (which === 'max' && Number(this.maxRange.value) < Number(this.minRange.value) + 1) {
      this.maxRange.value = Number(this.minRange.value) + 1;
    }
    this.updateUI();
  }

  updateUI() {
    const minVal = Number(this.minRange.value);
    const maxVal = Number(this.maxRange.value);
    const minPercent = (minVal / this.rangeMax) * 100;
    const maxPercent = (maxVal / this.rangeMax) * 100;

    this.fill.style.left = minPercent + '%';
    this.fill.style.right = 100 - maxPercent + '%';
    this.minLabel.textContent = this.currencySymbol + minVal.toFixed(2);
    this.maxLabel.textContent = this.currencySymbol + maxVal.toFixed(2);
  }

  commit() {
    this.minInput.value = this.minRange.value;
    this.maxInput.value = this.maxRange.value;
    [this.minInput, this.maxInput].forEach((input) => {
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
}

function initPriceSliders() {
  document.querySelectorAll('.facets__price:not([data-slider-init])').forEach((container) => {
    new PriceRangeSlider(container);
  });
}

document.addEventListener('DOMContentLoaded', initPriceSliders);

document.querySelectorAll('.facets-container').forEach((el) => {
  new MutationObserver(initPriceSliders).observe(el, { childList: true, subtree: true });
});